var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrrapper",attrs:{"id":"dcotors"}},[_c('page-heading',{attrs:{"title":"Doctors"}}),_c('data-table',{attrs:{"cols":_vm.columns,"rows":_vm.listEmployees,"height":"calc(100vh - 14.5rem)","loading":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }